// extracted by mini-css-extract-plugin
module.exports = {"submenu":"Submenu_submenu__23g_-","main":"Submenu_main__3XWIf","link-container":"Submenu_link-container__3jHYB","active-link":"Submenu_active-link__3wsAH"};